import BaseAPIClient from './base/BaseAPIClient';
import PdfFileModel from '../models/PdfFileModel';

export default class InfoClient extends BaseAPIClient {
  getEmbedFile(id) {
    return this._get(`file_uploads/pdf_embed/${id}/`).then(r => new PdfFileModel(r));
  }
}
